export default "__VITE_ASSET__BctB9QPf__"